export default "__VITE_ASSET__CMklfKw8__"